export const citizenships = [
  "XXX",
  "AFG",
  "ALA",
  "ALB",
  "DZA",
  "ASM",
  "USA",
  "AND",
  "AGO",
  "AIA",
  "ATA",
  "ATG",
  "ARE",
  "ARG",
  "ARM",
  "ABW",
  "AZE",
  "AUS",
  "AUT",
  "BHS",
  "BHR",
  "BGD",
  "BRB",
  "PLW",
  "BEL",
  "BLZ",
  "BEN",
  "BMU",
  "BTN",
  "BOL",
  "BES",
  "BIH",
  "BWA",
  "BVT",
  "BRA",
  "IOT",
  "VGB",
  "BRN",
  "BGR",
  "BFA",
  "BDI",
  "CPV",
  "COL",
  "COK",
  "CRI",
  "CIV",
  "CUW",
  "DJI",
  "DMA",
  "DOM",
  "ECU",
  "EST",
  "EGY",
  "GNQ",
  "SLV",
  "ERI",
  "SWZ",
  "ETH",
  "FLK",
  "FJI",
  "PHL",
  "FRO",
  "GAB",
  "GMB",
  "GHA",
  "GIB",
  "GRD",
  "GEO",
  "GRL",
  "GLP",
  "GUM",
  "GTM",
  "GGY",
  "GIN",
  "GNB",
  "GUY",
  "HTI",
  "HMD",
  "CHN",
  "ESP",
  "NLD",
  "HND",
  "HKG",
  "HRV",
  "TLS",
  "IRL",
  "ISR",
  "IND",
  "IDN",
  "IRQ",
  "IRN",
  "ISL",
  "ITA",
  "JPN",
  "JAM",
  "YEM",
  "JEY",
  "JOR",
  "CXR",
  "CYM",
  "KHM",
  "CMR",
  "CAN",
  "KAZ",
  "QAT",
  "KEN",
  "CAF",
  "KIR",
  "COM",
  "COD",
  "COG",
  "CCK",
  "PRK",
  "KOR",
  "XXK",
  "GRC",
  "CUB",
  "KWT",
  "KGZ",
  "CYP",
  "LAO",
  "LTU",
  "LSO",
  "LBR",
  "LIE",
  "LBN",
  "LBY",
  "LUX",
  "ZAF",
  "SGS",
  "SSD",
  "LVA",
  "ESH",
  "MAC",
  "MDG",
  "MYS",
  "MWI",
  "MDV",
  "MLI",
  "MLT",
  "IMN",
  "MAR",
  "MHL",
  "MTQ",
  "MRT",
  "MUS",
  "MYT",
  "MEX",
  "FSM",
  "MDA",
  "MCO",
  "MNG",
  "MNE",
  "MSR",
  "MOZ",
  "MMR",
  "NAM",
  "NRU",
  "NPL",
  "NIC",
  "NGA",
  "NER",
  "NIU",
  "NFK",
  "NOR",
  "OMN",
  "PNG",
  "PAK",
  "PSE",
  "PAN",
  "PRY",
  "PER",
  "PCN",
  "POL",
  "PRT",
  "GUF",
  "ATF",
  "PYF",
  "FRA",
  "PRI",
  "MKD",
  "MNP",
  "REU",
  "SWE",
  "ROU",
  "RWA",
  "SLB",
  "SHN",
  "KNA",
  "LCA",
  "MAF",
  "VCT",
  "BLM",
  "SPM",
  "DEU",
  "ZMB",
  "WSM",
  "SMR",
  "STP",
  "SAU",
  "SYC",
  "SEN",
  "SRB",
  "SLE",
  "SGP",
  "SXM",
  "SVK",
  "SVN",
  "SOM",
  "FIN",
  "LKA",
  "SDN",
  "SUR",
  "GBR",
  "SJM",
  "SYR",
  "ZWE",
  "TCD",
  "DNK",
  "TJK",
  "THA",
  "TWN",
  "TZA",
  "CZE",
  "CHL",
  "TGO",
  "TKL",
  "TON",
  "TTO",
  "TUN",
  "TCA",
  "TUV",
  "TUR",
  "TKM",
  "UGA",
  "UKR",
  "HUN",
  "URY",
  "VIR",
  "UMI",
  "UZB",
  "NCL",
  "NZL",
  "BLR",
  "VUT",
  "VAT",
  "CHE",
  "RUS",
  "VEN",
  "VNM",
  "WLF",
];
